import React from 'react'
import {
  IProps as IWhatsIncluded,
  WhatsIncluded,
} from 'marketing-site/src/library/components/WhatsIncluded'

import { IWhatsIncluded as IContentfulWhatsIncluded } from 'marketing-site/@types/generated/contentful'
import { transformWhatsIncludedItem } from 'marketing-site/src/transformers/elements/ContentfulWhatsIncludedItem'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import * as Utils from 'marketing-site/src/library/utils'
import { transformCTAWithBackground } from '../elements/ContentfulCTALink'

export const ContentfulWhatsIncluded = (whatsIncluded: IContentfulWhatsIncluded) => (
  <EntryMarker entry={whatsIncluded}>
    {() => <WhatsIncluded {...transformWhatsIncluded(whatsIncluded)} />}
  </EntryMarker>
)

export function transformWhatsIncluded({ fields }: IContentfulWhatsIncluded): IWhatsIncluded {
  return {
    ...fields,
    slides: fields.products.map(transformWhatsIncludedItem),
    bgColor: Utils.getHexColorFromName(fields.theme),
    ctaLink: fields.ctaLink && transformCTAWithBackground(fields.ctaLink),
  }
}
